import React, { useCallback, useEffect, useState } from 'react';
import type { TagWithUsage } from '../types';
import { createTag, deleteTag, listTagsWithUsage } from '../api';
import { useScope } from '../scopeContext';
import ProjectPicker from './ProjectPicker';

const TagManager: React.FC = () => {
  const [tags, setTags] = useState<TagWithUsage[]>([]);
  const [loading, setLoading] = useState(false);
  const [newTagName, setNewTagName] = useState('');
  const [error, setError] = useState('');
  const { scope } = useScope();

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await listTagsWithUsage(scope);
      setTags(res.tags);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Failed to load tags');
    } finally {
      setLoading(false);
    }
  }, [scope]);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <div>
      <ProjectPicker />
      <h2 style={{ margin: '0 0 12px 0' }}>Tags</h2>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          const value = newTagName.trim();
          if (!value) return;
          await createTag(value, scope);
          setNewTagName('');
          await load();
        }}
        style={{ display: 'flex', gap: 8, marginBottom: 12 }}
      >
        <input value={newTagName} onChange={(e) => setNewTagName(e.target.value)} placeholder="New tag" style={{ padding: 8, border: '1px solid #ddd', borderRadius: 6 }} />
        <button type="submit" className="button button-primary">Add</button>
      </form>
      {error && <div style={{ color: '#8b0000', marginBottom: 8 }}>{error}</div>}
      {loading ? <div>Loading...</div> : (
        <table className="data-table">
          <thead><tr><th>Tag name</th><th>Seeds</th><th>Batches</th><th>Actions</th></tr></thead>
          <tbody>
            {tags.map((tag) => (
              <tr key={tag.name}>
                <td>{tag.name}</td><td>{tag.seed_count}</td><td>{tag.batch_count}</td>
                <td>{scope.project_id && <button type="button" className="button" onClick={async () => { await deleteTag(tag.name, scope); await load(); }}>Remove</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TagManager;
